import { Vector as VectorSource } from 'ol/source';

import GeoJSON from 'ol/format/GeoJSON';


const Cinemas = async () => {
	var source = await fetch(process.env.PUBLIC_URL +"/couches/cinema_audivisuel.geojson");
	var cinemas = await source.text();
	
	return new VectorSource({
		features: new GeoJSON().readFeatures(cinemas),
	});
}

export default Cinemas;